






































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import moment from "moment";
// components
import PlayerScreenshotPreview from "@/components/players/modals/PlayerScreenshotPreview.vue";
// types
import { PlayerActionType, PlayerMultipleActionDto } from "@/services/players/types";
import { Solution } from "@/services/solutions/types";
import { Guid } from "guid-typescript";
import { SCREENSHOTENDPOINT } from "@/app.config";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";
// service methods
import { setMultipleAction } from "@/services/players/playerService";
import { GetSolutionStatus } from "@/services/solutions/solutionService";
import i18n from "@/i18n";

@Component({
    components: { PlayerScreenshotPreview }
})
export default class ScreenshotsTileView extends Vue {
    @Prop() solutions!: Solution[];
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;

    // local state
    isBusy = false;
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;
    getSolutionStatus = GetSolutionStatus;
    // filter options
    screenshotTimer = 0;

    // lifecycle hooks
    created() {
        this.initTimer();
    }

    destroyed() {
        clearTimeout(this.screenshotTimer);
    }

    // methods
    get model() {
        return this.solutions.sort((a: Solution, b: Solution) => {
            const textA = a.name ? a.name.toUpperCase() : "";
            const textB = b.name ? b.name.toUpperCase() : "";
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
    }

    initTimer() {
        clearTimeout(this.screenshotTimer);
        this.screenshotTimer = setTimeout(this.fetchData, 20000);
    }

    screenshotSrc(solution: Solution): string {
        if (solution.player) {
            return `${SCREENSHOTENDPOINT}${solution.player.playerId}?random=${Guid.create().toString()}`;
        } else {
            return "";
        }
    }

    fetchData() {
        this.$emit("fetchData");
        this.initTimer();
        this.$forceUpdate();
    }

    orderMultipleScreenshot() {
        setMultipleAction({
            actionType: PlayerActionType.screenshot,
            massAction: false,
            players: this.solutions.filter(x => x.playerId !== "" && x.playerId !== undefined && x.playerId !== null).map((y: Solution) => y.playerId)
        } as PlayerMultipleActionDto).then(() => {
            this.fetchData();
        });
    }

    previewScreenshot(playerId: number) {
        (this.$refs.playerScreenshotPreviewModal as any).open(playerId);
    }

    timeStampFormatted(date: Date) {
        if (!date) return "";
        const localDate = moment.utc(date).local();
        return `${localDate.format("ll")} ${localDate.format("HH:mm")}`;
    }

    formatDate(date: Date) {
        return moment.utc(date).local().format("LLL");
    }

    spinnerStatus(solution: Solution): boolean {
        if (solution.player && solution.player.lastScreenshotRequestedDate !== null) {
            const lastScreenshotRequestedDate = moment.utc(solution.player.lastScreenshotRequestedDate);
            const screenshotTimestamp = moment.utc(solution.player.screenshotTimestamp!);
            const now = moment.utc(new Date());

            if (screenshotTimestamp > lastScreenshotRequestedDate) return false;

            const duration = moment.duration(now.diff(lastScreenshotRequestedDate));
            const minutes = duration.asMinutes();
            // show spinner up to 2 minutes after a screenshot is requested
            return minutes < 2;
        }
        return false;
    }

    screenshotStatus(solution: Solution) {
        if (solution.player && solution.player.lastScreenshotRequestedDate !== null && solution.player.screenshotTimestamp !== null) {
            const lastScreenshotRequestedDate = moment.utc(solution.player.lastScreenshotRequestedDate);
            const screenshotTimestamp = moment.utc(solution.player.screenshotTimestamp);
            return screenshotTimestamp > lastScreenshotRequestedDate;
        }
        return false;
    }

    updateSolutionSettingsRoute(solutionId: string) {
        return {
            name: "updateSolution",
            params: { solutionId: solutionId }
        };
    }
}
